/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */

import React from 'react';

import { useSelector } from 'react-redux';

import './SummaryLayout.scss';
import config from '../../../config/config';
import errorStyles from '../../../containers/landing/ErrorPage.module.scss';
// Components
import InfoBar from './Bar/Info/InfoBar';
import RMDComponent from './RMDComponent/RMDComponent';
import ErrorPage from '../../../containers/landing/ErrorPage';

const SummaryLayout = () => {
  const isEligible = useSelector(
    (state) => state.RMDSetting.rmdLimitsData?.eligibleForRMD
  );
  const checkEligiblity = () => {
    if (isEligible) {
      return <RMDComponent />;
    } else {
      return (
        <ErrorPage
          errorMsg={null}
          errorHeading={{
            msg: `Unfortunately, we’re not able to manage your Required Minimum Distribution (RMD) online.`,
            style: 'title',
          }}
          errorRedirect={{
            link: 'usis/my-accounts/dashboard',
            text: 'Return to Dashboard',
          }}
          errorPageBody={
            <div className={errorStyles['rmd-error-body']}>
              <p>This may be because: </p>
              <ul className={errorStyles['bulltes-points-rmd-errors']}>
                <li>
                  You're under the age for RMDs (minimum 73 years as of December
                  31st of this year)
                </li>
                <li>
                  You didn’t have an account, as of December 31 of last year,
                  that required an RMD, OR
                </li>
                <li>
                  We’re not currently able to support this experience for the
                  following accounts:
                  <br />
                  Workplace Retirement or Inherited IRA.
                </li>
              </ul>
              <p className={errorStyles['bulltes-points-rmd-errors']}>
                To learn more about RMDs, please visit{' '}
                <a
                  className={errorStyles['error-link']}
                  rel="noopener noreferrer"
                  href={`${config.url}/personal-investing/resources/planning/rmds/index.html`}
                  target="_blank"
                >
                  troweprice.com/rmd
                </a>
              </p>
              <p className={errorStyles['mr-top']}>
                As always, please{' '}
                <a
                  className={'error-link'}
                  rel="noopener noreferrer"
                  href={`${config.url}/personal-investing/help/contact/index.html`}
                  target="_blank"
                >
                  contact us
                </a>{' '}
                with any questions
              </p>
            </div>
          }
        />
      );
    }
  };

  return (
    <div id="summary-layout" className={!isEligible && 'full-white-background'}>
      {isEligible && <InfoBar />}
      <div>{checkEligiblity()}</div>
    </div>
  );
};

export default SummaryLayout;
